import { widgetManager } from '../../src/widgetManager/index.js'
import config from '/config/config.js'
import templates from '/app/templates'
import BaseChannel from './base'

const DEFAULT_COUNTRY = 'pl'

const defaultToggleChatTexts = {
  chatHide: 'Hide chat',
  chatShow: 'Show chat',
  settings: 'Settings',
  fullScreen: 'Full screen',
  blurBackground: 'Blur background',
}

export default class GenesysVideoChannel extends BaseChannel {
  constructor(
    settings,
    {
      i18n,
      widgetContainer,
      genesysVideoService,
      texts,
      widgetIndex,
      singleChannelBehavior,
      chatCall,
      type,
      preInteractionForm,
      validatePreInteractionForm,
      initPreInteractionForm,
      adjustPreInteractionFormConsentsStyles,
    }
  ) {
    super(settings, { widgetContainer })
    this.i18n = i18n
    this.texts = texts
      .filter((x) => x.type === 'video')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})
    Object.keys(defaultToggleChatTexts).forEach((key) => {
      if (!this.texts.hasOwnProperty(key)) {
        this.texts[key] = defaultToggleChatTexts[key]
      }
    })
    this.cobrowseTexts = texts
      .filter((x) => x.type === 'cobrowse')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})
    this.preInteractionFormTexts = texts
      .filter((x) => x.type === 'preInteractionForm')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})
    this.type = type ? type : 'video'
    this.chatCall = chatCall ? chatCall : false
    this.texts.mobileSettingsLabel = this.texts.mobileSettingsLabel || 'Audio'
    this.fields = settings.fields || []
    this.room
    this.sipState = {}
    this.lastExecutionTime = 0

    this.preInteractionForm = preInteractionForm
    this.preInteractionFormEnabled = false
    this.validatePreInteractionForm = validatePreInteractionForm
    this.initPreInteractionForm = initPreInteractionForm
    this.filerCountriesText = texts.find((x) => x.key === 'filterCountries')?.value || 'Filter countries'
    this.adjustPreInteractionFormConsentsStyles = adjustPreInteractionFormConsentsStyles
    this.selectedFormType = ''
    this.preInteractionFormIti = {}

    if (preInteractionForm && Object.keys(preInteractionForm).length > 0) {
      this.preInteractionFormEnabled = preInteractionForm.video.enabled
    }

    this.cobrowseCode = ''
    this.widgetIndex = widgetIndex
    this.hideInfoTimeout = null

    this.showVideoBlur = this.fields[0].showVideoBlur
    this.remoteName = window.trueengage.get('videoRemoteName')

    this.justVoice = false

    try {
      this.sipState = {
        accountId: parseInt(widgetContainer.settings.id),
        widgetId: parseInt(widgetContainer.settings.widgets[0].id),
        url: location.href,
        visitorId: this.widgetContainer.token,
        gaClientId: this.widgetContainer.googleAnalyticsClientId,
      }
    } catch (e) {
      console.error(e)
    }

    this.activeCall = null
    this.genesysVideoService = genesysVideoService
    this.hubConnection = {}

    this.callStats = {
      audio_packets_lost: 0,
      audio_packets_received: 0,
      audio_jitter: 0,
      audio_round_trip_time: 0,
      audio_jitterSum: 0,
      audio_rttSum: 0,
      audio_jitterCount: 0,
      audio_rttCount: 0,

      video_packets_lost: 0,
      video_packets_received: 0,
      video_jitter: 0,
      video_round_trip_time: 0,
      video_jitterSum: 0,
      video_rttSum: 0,
      video_jitterCount: 0,
      video_rttCount: 0,
    }

    this.isMobile = this.isMobile()

    this.channelType = 'video'
    this.singleChannelBehavior = singleChannelBehavior
    this.roomId = ''
    this.settings = settings
    this.audioTrack = null
    this.videoTrack = null
    this.videoBlurTrack = null
  }

  setup() {
    if (this.chatCall) {
      this.styleNamespace = 'cce-widget-video open'
    } else {
      this.styleNamespace = 'cce-widget-video'
    }
  }

  isMobile() {
    const isMobile = /iPhone|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && !/iPad/i.test(navigator.userAgent)
    const isPhone = screen.width <= 768
    return isMobile && isPhone
  }

  isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  }

  async open(justVoice) {
    this.$element = document.createElement('div')
    this.$element.classList.add(this.styleNamespace, justVoice && 'justAudio')
    await this.render()

    this.getMediaDevices()

    setTimeout(() => {
      const targetNode = document.querySelector('.cce-widget-video')
      this.justVoice = targetNode.className.split(' ').includes('justAudio')
      if (this.justVoice) {
        var chatAvatar = document.querySelector('.cce-widget_header--channel__chat-avatar-img').src
        if (chatAvatar) {
          var avatarImg = document.querySelectorAll('.cce-widget-video__avatar')[0].querySelectorAll('img')[1]
          avatarImg.src = chatAvatar
        }
        this.widgetContainer.playRingtone()
        const turnCameraButton = document.getElementById(`${this.styleNamespace}__turn_camera`)
        if (turnCameraButton) turnCameraButton.remove()

        const blurButton = document.querySelector(`.${this.styleNamespace}__more__options_list #toggle_blur`)
        if (blurButton) blurButton.remove()

        const videoButton = document.querySelector(`#${this.styleNamespace}__camera_toggle`)
        if (videoButton) videoButton.parentElement.remove()

        const orgheader = document.querySelector(`.${this.styleNamespace}__header`)
        if (orgheader) orgheader.remove()

        const orgAvatars = document.querySelector(`.${this.styleNamespace}__avatar-wrapper-hide`)
        if (orgAvatars) orgheader.remove()

        const chatShowBtn = document.querySelector(`.chat-show`)
        if (chatShowBtn) orgheader.style.display = 'none'
      }
      if (targetNode) {
        if (targetNode.className.split(' ').includes('chatCall')) {
          this.setStatusClass('in-progress')
        }
      }
    }, 0)

    this.removeCoBrowseInfoPanel()

    this.initVideo()
    this.genesysVideoService.getWebRTCToken({}, (data) => {
      this.initWebRTC(data.token)
    })
  }

  getMediaDevices() {
    if (this.justVoice) {
      return navigator.mediaDevices.getUserMedia({ video: false, audio: true })
    }
    return navigator.mediaDevices.getUserMedia({ video: true, audio: true })
  }

  removeCoBrowseInfoPanel() {
    if (this.hideInfoTimeout) {
      clearTimeout(this.hideInfoTimeout) // Kasujemy timer, jeśli istnieje
      this.hideInfoTimeout = null
    }

    var placement = this.widgetContainer.settings.widgets[this.widgetIndex].placement
    const coBrowseWrapper = document.getElementsByClassName(`cce-widget-video__cobrowse-wrapper-${placement}`)[0]

    if (coBrowseWrapper) {
      coBrowseWrapper.style.display = 'none'
    }
  }

  showCoBrowseInfo() {
    var placement = this.widgetContainer.settings.widgets[this.widgetIndex].placement

    const coBrowseWrapper = document.getElementsByClassName(`cce-widget-video__cobrowse-wrapper-${placement}`)[0]

    if (coBrowseWrapper) {
      coBrowseWrapper.style.display = 'flex'
    }

    this.hideInfoTimeout = setTimeout(() => {
      this.removeCoBrowseInfoPanel()
    }, 300000)

    document.getElementsByClassName(`${this.styleNamespace}__cobrowse-button-accept`)[0].addEventListener('click', async () => {
      Genesys(
        'command',
        'CobrowseService.acceptSession',
        {
          joinCode: this.cobrowseCode,
        },
        async () => {
          console.log('Co-browse session successfully accepted')
          this.removeCoBrowseInfoPanel()
          await this.hubConnection.invoke('SendCobrowseResult', this.widgetContainer.settings.id, this.widgetContainer.token, 'accepted')
        },
        (err) => {
          console.log('could not accept Co-browse session, error code: ', err.code)
        }
      )
    })

    document.getElementsByClassName(`${this.styleNamespace}__cobrowse-button-reject`)[0].addEventListener('click', async () => {
      await this.hubConnection.invoke('SendCobrowseResult', this.widgetContainer.settings.id, this.widgetContainer.token, 'rejected')
      this.removeCoBrowseInfoPanel()
    })
  }

  generateUUID() {
    var d = new Date().getTime()
    var d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16
      if (d > 0) {
        r = (d + r) % 16 | 0
        d = Math.floor(d / 16)
      } else {
        r = (d2 + r) % 16 | 0
        d2 = Math.floor(d2 / 16)
      }
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
  }

  async joinInteractionViaHub(roomId = this.roomId) {
    if (this.justVoice) {
      roomId = `TE_AUDIO_${this.roomId}`
    }
    await this.hubConnection.start()
    await this.hubConnection.invoke('JoinInteractionGroup', this.widgetContainer.settings.id, this.widgetContainer.token)
    await this.hubConnection.invoke('SendRoomId', this.widgetContainer.settings.id, this.widgetContainer.token, roomId)
    await this.hubConnection.stop()
  }

  async initVideo() {
    const context = this.widgetContainer.token
    let roomResponse = await this.genesysVideoService.createVideoRoom(`${context}_${this.generateUUID()}`)
    this.roomId = roomResponse.room_id
    this.sipState.roomId = this.roomId
    roomResponse = await this.genesysVideoService.createVideoRoomToken(this.roomId)
    const clientToken = roomResponse.token

    this.room = await TelnyxVideo.initialize({
      roomId: this.roomId,
      clientToken,
      context,
      enableMessages: true,
      process: {},
    })

    const targetNode = document.querySelector('.cce-widget-video')
    if (targetNode.className.split(' ').includes('chatCall')) {
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(config.interactionHub.host, { withCredentials: false })
        .configureLogging(signalR.LogLevel.Information)
        .build()

      await this.joinInteractionViaHub()
    }

    this.room.on('connected', async () => {
      console.log('Connected to the room')
      let callerStream
      let audioDeviceId
      const devices = await navigator.mediaDevices.enumerateDevices()
      devices.forEach((device) => {
        if (device.kind === 'audioinput' && device.deviceId === 'communications') {
          audioDeviceId = device.deviceId
        }
      })

      if (this.justVoice) {
        callerStream = await navigator.mediaDevices.getUserMedia({
          audio: { deviceId: audioDeviceId ? audioDeviceId : undefined },
          video: false,
        })

        var ringingHeader = document.getElementById('ringing_voice')
        if (ringingHeader) {
          ringingHeader.style.display = 'none'
        }

        var inpgoressHeader = document.getElementById('in-progress_voice')
        if (inpgoressHeader) {
          inpgoressHeader.style.display = 'block'
        }
      } else {
        callerStream = await navigator.mediaDevices.getUserMedia({
          audio: { deviceId: audioDeviceId ? audioDeviceId : undefined },
          video: true,
        })
      }

      this.audioTrack = callerStream.getAudioTracks()[0]
      this.videoTrack = this.justVoice ? null : callerStream.getVideoTracks()[0]

      if (this.justVoice) {
        await this.room.addStream('visitor', {
          audio: this.audioTrack,
        })
      } else {
        await this.room.addStream('visitor', {
          audio: this.audioTrack,
          video: this.videoTrack,
        })
      }

      const blurButton = document.querySelector(`.${this.styleNamespace}__more__options_list #toggle_blur`)
      const moreOptionsList = this.$element.querySelector(`.${this.styleNamespace}__more__options_list`)
      const videoWrapper = document.querySelector(`.${this.styleNamespace}__video-wrapper-caller`)
      const turnCameraButton = document.querySelector(`#${this.styleNamespace}__turn_camera`)
      const videoButton = document.querySelector(`#${this.styleNamespace}__camera_toggle`)
      const audioButton = document.querySelector(`#${this.styleNamespace}__mute`)
      const videoSource = document.getElementById('caller')

      let supports = navigator.mediaDevices.getSupportedConstraints()
      if (!this.justVoice && supports['facingMode'] === true) {
        turnCameraButton.disabled = false
      }

      navigator.mediaDevices.enumerateDevices().then((devices) => {
        const audioOutputCombobox = this.$element.querySelector(`[name=${this.styleNamespace}__call-settings__output]`)
        const audioInputCombobox = this.$element.querySelector(`[name=${this.styleNamespace}__call-settings__input]`)
        const videoCombobox = this.$element.querySelector(`[name=${this.styleNamespace}__call-settings__video-input]`)
        const mobileCombobox = this.$element.querySelector(`[name=${this.styleNamespace}__call-settings__mobileSettings`)

        const clearSelectOptions = (selectElement) => {
          if (selectElement) {
            selectElement.options.length = 0
          }
        }

        if (this.isMobile) {
          clearSelectOptions(mobileCombobox)

          const audioOutputDevices = devices.filter((device) => device.kind === 'audiooutput')
          const audioInputDevices = devices.filter((device) => device.kind === 'audioinput')

          audioInputDevices.forEach((device) => {
            let selected = false
            if (device.deviceId === 'communications') selected = true

            const option = new Option(device.label, device.deviceId, selected, selected)
            mobileCombobox.add(option)
          })

          audioOutputDevices.forEach((device) => {
            let selected = false
            if (device.deviceId === 'communications') selected = true

            const option = new Option(device.label, device.deviceId, selected, selected)
            mobileCombobox.add(option)
          })

          mobileCombobox.addEventListener('change', async (event) => {
            const element = event.target
            const deviceId = element.value

            const stream = await navigator.mediaDevices.getUserMedia({
              audio: { deviceId: deviceId },
            })

            const audioTrack = stream.getAudioTracks()[0]

            this.audioTrack = audioTrack
            this.room.updateStream('visitor', {
              audio: audioTrack,
              video: this.videoTrack,
            })
          })
        } else {
          clearSelectOptions(audioOutputCombobox)
          clearSelectOptions(audioInputCombobox)
          clearSelectOptions(videoCombobox)

          const audioOutputDevices = devices.filter((device) => device.kind === 'audiooutput')
          const audioInputDevices = devices.filter((device) => device.kind === 'audioinput')
          const videoDevices = devices.filter((device) => device.kind === 'videoinput')

          videoDevices.forEach((device) => {
            let selected = false
            if (device.deviceId === 'communications') selected = true

            const option = new Option(device.label, device.deviceId, selected, selected)
            videoCombobox.add(option)
          })

          videoCombobox.addEventListener('change', async (event) => {
            const element = event.target
            const deviceId = element.value

            const stream = await navigator.mediaDevices.getUserMedia({
              video: { deviceId: deviceId },
            })

            this.videoTrack = stream.getVideoTracks()[0]
            videoSource.srcObject = stream
            this.room.updateStream('visitor', {
              audio: this.audioTrack,
              video: this.videoTrack,
            })
          })

          audioInputDevices.forEach((device) => {
            let selected = false
            if (device.deviceId === 'communications') selected = true

            const option = new Option(device.label, device.deviceId, selected, selected)
            audioInputCombobox.add(option)
          })

          audioInputCombobox.addEventListener('change', async (event) => {
            const element = event.target
            const deviceId = element.value

            const stream = await navigator.mediaDevices.getUserMedia({
              audio: { deviceId: deviceId },
            })

            const audioTrack = stream.getAudioTracks()[0]
            this.audioTrack = audioTrack
            this.room.updateStream('visitor', {
              audio: audioTrack,
              video: this.videoTrack,
            })
          })

          audioOutputDevices.forEach((device) => {
            let selected = false
            if (device.deviceId === 'communications') {
              selected = true
            }

            const option = new Option(device.label, device.deviceId, selected, selected)
            audioOutputCombobox.add(option)
          })

          audioOutputCombobox.addEventListener('change', async (event) => {
            if (this.justVoice) {
              const calleeAudioSource = document.getElementById('calleeAudio')
              const element = event.target
              const deviceId = element.value
              await calleeAudioSource.setSinkId(deviceId)
            } else {
              const calleeVideoSource = document.getElementById('callee')
              const element = event.target
              const deviceId = element.value
              await calleeVideoSource.setSinkId(deviceId)
            }
          })
        }
      })

      const applyBlurOnVideo = async () => {
        const video = document.getElementById('caller')
        const canvas = document.getElementById('canvasCaller')

        const canvasCtx = canvas.getContext('2d')

        canvas.width = video.videoWidth
        canvas.height = video.videoHeight

        const selfieSegmentation = new SelfieSegmentation({
          locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
        })

        selfieSegmentation.setOptions({
          modelSelection: 1,
        })

        const onResults = (results) => {
          if (this.isSafari()) {
            const backgroundCanvas = document.createElement('canvas')
            const backgroundCtx = backgroundCanvas.getContext('2d')
            backgroundCanvas.width = canvas.width
            backgroundCanvas.height = canvas.height

            const foregroundCanvas = document.createElement('canvas')
            const foregroundCtx = foregroundCanvas.getContext('2d')
            foregroundCanvas.width = canvas.width
            foregroundCanvas.height = canvas.height

            const offsets = [
              { x: -10, y: -10 },
              { x: 10, y: 10 },
              { x: -5, y: 5 },
              { x: 5, y: -5 },
              { x: 0, y: 0 },
            ]

            offsets.forEach((offset) => {
              backgroundCtx.globalAlpha = 0.15
              backgroundCtx.drawImage(results.image, offset.x, offset.y, canvas.width, canvas.height)
            })
            backgroundCtx.globalAlpha = 1.0

            const imageData = backgroundCtx.getImageData(0, 0, backgroundCanvas.width, backgroundCanvas.height)
            const data = imageData.data

            for (let i = 0; i < data.length; i += 4) {
              const noise = (Math.random() - 0.5) * 30
              data[i] = Math.min(Math.max(data[i] + noise, 0), 255)
              data[i + 1] = Math.min(Math.max(data[i + 1] + noise, 0), 255)
              data[i + 2] = Math.min(Math.max(data[i + 2] + noise, 0), 255)
            }

            backgroundCtx.putImageData(imageData, 0, 0)
            backgroundCtx.fillStyle = 'rgba(0, 0, 0, 0.3)'
            backgroundCtx.fillRect(0, 0, backgroundCanvas.width, backgroundCanvas.height)

            foregroundCtx.drawImage(results.segmentationMask, 0, 0, canvas.width, canvas.height)
            foregroundCtx.globalCompositeOperation = 'source-in'
            foregroundCtx.drawImage(results.image, 0, 0, canvas.width, canvas.height)

            canvasCtx.clearRect(0, 0, canvas.width, canvas.height)
            canvasCtx.drawImage(backgroundCanvas, 0, 0)
            canvasCtx.drawImage(foregroundCanvas, 0, 0)

            requestAnimationFrame(() => selfieSegmentation.send({ image: video }))
          } else {
            canvasCtx.save()
            canvasCtx.clearRect(0, 0, canvas.width, canvas.height)

            canvasCtx.drawImage(results.segmentationMask, 0, 0, canvas.width, canvas.height)
            canvasCtx.globalCompositeOperation = 'source-in'
            canvasCtx.drawImage(results.image, 0, 0, canvas.width, canvas.height)
            canvasCtx.globalCompositeOperation = 'destination-atop'

            canvasCtx.filter = 'blur(20px)'
            canvasCtx.drawImage(results.image, 0, 0, canvas.width, canvas.height)
            canvasCtx.restore()

            requestAnimationFrame(() => selfieSegmentation.send({ image: video }))
          }
        }

        const processVideoFrames = () => {
          selfieSegmentation.onResults(onResults)
          selfieSegmentation.send({ image: video })
        }

        processVideoFrames()

        const canvasStream = canvas.captureStream(30)
        this.videoBlurTrack = canvasStream.getVideoTracks()[0]

        await this.room.updateStream('visitor', {
          audio: this.audioTrack,
          video: this.videoBlurTrack,
        })
        const canvasElement = document.querySelector(`.cce-widget-video__video-wrapper-canvas`).classList
        canvasElement.remove('hide')
        canvasElement.add('active')
      }

      if (videoButton) {
        videoButton.addEventListener('click', async () => {
          const canvasElement = document.querySelector(`.cce-widget-video__video-wrapper-canvas`).classList
          if (videoButton.classList.contains('muted')) {
            blurButton.disabled = false
            if (canvasElement.contains('active')) {
              const canvasElement = document.querySelector(`.cce-widget-video__video-wrapper-canvas`).classList
              canvasElement.remove('hide')
              this.room.updateStream('visitor', {
                audio: this.audioTrack,
                video: this.videoBlurTrack,
              })
              videoButton.classList.remove('muted')
              return
            }
            this.room.updateStream('visitor', {
              audio: this.audioTrack,
              video: this.videoTrack,
            })
            videoButton.classList.remove('muted')
            videoWrapper.classList.remove('hide')
          } else {
            blurButton.disabled = true
            this.room.updateStream('visitor', {
              audio: this.audioTrack,
              video: undefined,
            })
            canvasElement.add('hide')
            videoWrapper.classList.add('hide')
            videoButton.classList.add('muted')
          }
        })
      }

      if (audioButton) {
        audioButton.addEventListener('click', async () => {
          if (audioButton.classList.contains('muted')) {
            audioButton.classList.remove('muted')
            this.audioTrack.enabled = true
          } else {
            audioButton.classList.add('muted')
            this.audioTrack.enabled = false
          }
        })
      }

      if (!this.justVoice) {
        turnCameraButton.addEventListener('click', async () => {
          const currentFacingMode = this.videoTrack.getSettings().facingMode
          const newFacingMode = currentFacingMode === 'user' ? 'environment' : 'user'

          this.videoTrack.stop()
          if (this.videoBlurTrack) this.videoBlurTrack.stop()
          this.videoTrack = null
          this.videoBlurTrack = null
          const newStream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: newFacingMode },
            audio: this.audioTrack,
          })

          this.videoTrack = newStream.getVideoTracks()[0]
          videoSource.srcObject = newStream

          this.room.updateStream('visitor', {
            audio: this.audioTrack,
            video: this.videoTrack,
          })

          const canvasElement = document.querySelector(`.cce-widget-video__video-wrapper-canvas`).classList

          if (canvasElement.contains('active')) {
            setTimeout(async () => await applyBlurOnVideo(), 200)
          }
        })

        let videoElement = document.getElementById('caller')
        videoElement.srcObject = callerStream
      }

      if (blurButton) {
        blurButton.addEventListener('click', async () => {
          moreOptionsList.classList.toggle('show', false)
          const canvasElement = document.querySelector(`.cce-widget-video__video-wrapper-canvas`).classList
          if (canvasElement.contains('hide')) {
            if (this.videoBlurTrack !== null) {
              await this.room.updateStream('visitor', {
                audio: this.audioTrack,
                video: this.videoBlurTrack,
              })
              canvasElement.remove('hide')
              canvasElement.add('active')
            } else {
              await applyBlurOnVideo()
            }
          } else if (!canvasElement.contains('hide')) {
            await this.room.updateStream('visitor', {
              audio: this.audioTrack,
              video: this.videoTrack,
            })
            videoWrapper.classList.remove('hide')
            canvasElement.add('hide')
            canvasElement.remove('active')
          }
        })
      }

      document.querySelector('#cce-widget-video__hangup').addEventListener('click', () => {
        this.widgetContainer.stopRingtone()
        this.room.disconnect()
        const chatChannel = document.querySelector('.cce-widget-chat')
        const windowContent = document.querySelector('.cce-widget__window__content')
        const toggleChat = this.$element.querySelector(`.${this.styleNamespace}__video-wrapper-chat`)
        const back = document.querySelector('.cce-widget__window__header--back')
        const avatars = document.querySelector('.cce-widget-video__avatar-wrapper-voice')
        if (avatars) {
          avatars.classList.remove('chat-active')
        }
        back.classList.remove('cce-widget__window__header--back-hide')
        const localVideoWrapper = document.querySelectorAll(
          '.cce-widget-video__video-wrapper-canvas, .cce-widget-video__video-wrapper-caller, .cce-widget-video__video-wrapper-template'
        )
        localVideoWrapper.forEach((video) => {
          video.classList.remove('chat-active')
        })
        toggleChat.classList.remove('chat-hide')
        toggleChat.classList.add('chat-show')
        if (chatChannel && windowContent) {
          windowContent.appendChild(chatChannel)
        }
      })
    })

    this.room.on('participant_joined', () => {
      const targetNode = document.querySelector('.cce-widget-video')
      if (!targetNode.className.split(' ').includes('chatCall') && !this.chatCall) {
        this.activeCall.muteAudio()
        this.activeCall.deaf()
      }

      if (this.showVideoBlur) {
        if (targetNode.className.split(' ').includes('chatCall') && this.chatCall) {
          return
        }
        const blurButton = document.querySelector(`.${this.styleNamespace}__more__options_list #toggle_blur`)
        blurButton.click()
      }
      document.getElementById(`${this.styleNamespace}__remoteMedia`).muted = true
    })

    this.room.on('stream_published', async (participantId, streamKey, state) => {
      const localStreamKey = streamKey
      const localParticipantId = participantId
      let participant = state.participants.get(participantId)
      if (participant.origin === 'local') {
        return
      }

      if (this.justVoice) {
        await this.room.addSubscription(participantId, streamKey, {
          audio: true,
          video: false,
        })
      } else {
        await this.room.addSubscription(participantId, streamKey, {
          audio: true,
          video: true,
        })
      }

      this.videoStatsInterval = setInterval(() => {
        this.room
          .getWebRTCStatsForStream(localParticipantId, localStreamKey)
          .then((stats) => {
            console.log('WebRTC Video stats')
            this.processVideoStat(stats)
          })
          .catch((error) => {
            console.error('Error fetching WebRTC stats:', error)
          })
      }, 2000)
    })

    this.room.on('participant_left', () => {
      this.hangupCall()
    })

    this.room.on('subscription_started', (participantId, streamKey) => {
      console.log(`subscription to the: ${participantId} ${streamKey} stream started...`)

      let remoteStream = this.room.getParticipantStream(participantId, streamKey)

      if (this.justVoice) {
        let remoteMediaStream = new MediaStream([remoteStream.audioTrack])
        const calleeAudio = document.getElementById('calleeAudio')
        calleeAudio.srcObject = remoteMediaStream
        this.setStatusClass('in-progress')
        this.widgetContainer.stopRingtone()
        this.$element.querySelector(`.${this.styleNamespace}__avatar-wrapper`).classList.add(`${this.styleNamespace}__avatar-wrapper-hide`)
      } else {
        let remoteMediaStream = new MediaStream([remoteStream.audioTrack, remoteStream.videoTrack])
        const calleeVideo = document.getElementById('callee')
        calleeVideo.srcObject = remoteMediaStream
        if (this.chatCall) {
          this.setStatusClass('in-progress')
        } else {
          widgetManager.setWidgetTab('trueengage.video.in-progress')
        }
        this.widgetContainer.stopRingtone()
        this.$element.querySelector(`.${this.styleNamespace}__avatar-wrapper`).classList.add(`${this.styleNamespace}__avatar-wrapper-hide`)
        calleeVideo.focus()

        calleeVideo.addEventListener('click', () => {
          calleeVideo.focus()
        })
      }
    })

    await this.room.connect()
    const observerConfig = { attributes: true, attributeFilter: ['class'] }
    const callback = async (mutationsList) => {
      const currentTime = Date.now()
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (targetNode.className.split(' ').includes('chatCall')) {
            if (!this.roomId) {
              await this.initVideo()
              return
            }
            if (currentTime - this.lastExecutionTime > 10000) {
              if (this.chatCall) {
                this.setStatusClass('in-progress')
              } else {
                widgetManager.setWidgetTab('trueengage.video.in-progress')
              }

              this.lastExecutionTime = currentTime
              this.hubConnection = new signalR.HubConnectionBuilder()
                .withUrl(config.interactionHub.host, { withCredentials: false })
                .configureLogging(signalR.LogLevel.Information)
                .build()

              await this.joinInteractionViaHub()
            }
          }
        }
      }
    }

    const observer = new MutationObserver(callback)
    observer.observe(targetNode, observerConfig)
  }

  initCoBrowse(depylomentId, environment, regionShort) {
    ;(function (g, e, n, es, ys) {
      g['_genesysJs'] = e
      g[e] =
        g[e] ||
        function () {
          ;(g[e].q = g[e].q || []).push(arguments)
        }
      g[e].t = 1 * new Date()
      g[e].c = es
      ys = document.createElement('script')
      ys.async = 1
      ys.src = n
      ys.charset = 'utf-8'
      document.head.appendChild(ys)
    })(window, 'Genesys', `https://apps.${environment}/genesys-bootstrap/genesys.min.js`, {
      environment: regionShort,
      deploymentId: depylomentId,
    })
  }

  initWebRTC(token) {
    return new Promise((resolve, reject) => {
      try {
        console.log('Init WebRTC')
        let client = new TelnyxWebRTC.TelnyxRTC({ login_token: token })
        client.remoteElement = `${this.styleNamespace}__remoteMedia`

        let settings = this.widgetContainer.settings.widgets[this.widgetIndex].additionalSettings.find((item) => item.key === 'voice_cobrowse')

        const createHubConnection = async () => {
          if (typeof Genesys === 'undefined' && typeof window.Genesys === 'undefined' && settings && settings.value) {
            this.initCoBrowse(settings.deploymentId, settings.environment, settings.regionShort)
          }

          this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(config.interactionHub.host, { withCredentials: false })
            .configureLogging(signalR.LogLevel.Information)
            .build()

          try {
            await this.hubConnection.start({ withCredentials: false })
          } catch (error) {
            return
          }
          await this.hubConnection.invoke('JoinInteractionGroup', this.widgetContainer.settings.id, this.widgetContainer.token)
          this.hubConnection.on('ReceiveCoBrowseOffer', (accountId, visitorId, code) => {
            if (this.widgetContainer.settings.id == accountId && this.widgetContainer.token == visitorId) {
              this.cobrowseCode = code
              //TODO show cobrowse offer
              //hide agent picture

              this.showCoBrowseInfo()
            }
          })
        }
        if (settings && settings.value) {
          createHubConnection()
        }

        client
          .on('telnyx.ready', () => {})
          .on('telnyx.error', () => console.log('error'))
          .on('telnyx.notification', (notification) => {
            if (notification.type === 'callUpdate') {
              if (notification.call.state === 'active') {
                this.widgetContainer.stopRingtone()
              }
              this.activeCall = notification.call
            }
            if (notification.call.state === 'hangup') {
              this.sendFinalStats()
            }
            if (notification.call.state === 'destroy' || notification.call.state === 'hangup') {
              this.widgetContainer.stopRingtone()
              this.activeCall = null
              this.hangupCall()
              this.removeCoBrowseInfoPanel()
            }
          })

        client.connect()

        this.webRTCClient = client
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  processStat(stat, video = false) {
    switch (stat.type) {
      case 'inbound-rtp':
        if (stat.kind === 'audio') {
          this.callStats.audio_packets_lost += stat.packetsLost
          this.callStats.audio_packets_received += stat.packetsReceived
          if (stat.jitter !== undefined) {
            this.callStats.audio_jitterSum += stat.jitter * 1000
            this.callStats.audio_jitterCount++
          }
        } else if (stat.kind === 'video') {
          this.callStats.video_packets_lost += stat.packetsLost
          this.callStats.video_packets_received += stat.packetsReceived
          if (stat.jitter !== undefined) {
            this.callStats.video_jitterSum += stat.jitter * 1000
            this.callStats.video_jitterCount++
          }
        }
        break
      case 'candidate-pair':
        if (stat.nominated && stat.state === 'succeeded') {
          if (!video) {
            if (stat.currentRoundTripTime !== undefined) {
              const rttMs = stat.currentRoundTripTime * 1000
              this.callStats.audio_rttSum += rttMs
              this.callStats.audio_rttCount++
            }
          } else if (video) {
            if (stat.currentRoundTripTime !== undefined) {
              const rttMs = stat.currentRoundTripTime * 1000
              this.callStats.video_rttSum += rttMs
              this.callStats.video_rttCount++
            }
          }
        }
        break
      default:
        break
    }
  }

  calculateFinalStats() {
    this.callStats.audio_jitter = this.callStats.audio_jitterCount > 0 ? this.callStats.audio_jitterSum / this.callStats.audio_jitterCount : 0
    this.callStats.audio_round_trip_time = this.callStats.audio_rttCount > 0 ? this.callStats.audio_rttSum / this.callStats.audio_rttCount : 0

    this.callStats.video_jitter = this.callStats.video_jitterCount > 0 ? this.callStats.video_jitterSum / this.callStats.video_jitterCount : 0
    this.callStats.video_round_trip_time = this.callStats.video_rttCount > 0 ? this.callStats.video_rttSum / this.callStats.video_rttCount : 0

    return {
      session_id: this.activeCall.session.uuid,
      visitor_id: this.widgetContainer.token,

      audio_packets_lost: this.callStats.audio_packets_lost,
      audio_packets_received: this.callStats.audio_packets_received,
      audio_jitter: this.callStats.audio_jitter,
      audio_round_trip_time: this.callStats.audio_round_trip_time,

      video_packets_lost: this.callStats.video_packets_lost,
      video_packets_received: this.callStats.video_packets_received,
      video_jitter: this.callStats.video_jitter,
      video_round_trip_time: this.callStats.video_round_trip_time,
    }
  }

  sendFinalStats() {
    const webrtcStats = this.calculateFinalStats()
    console.log(webrtcStats)
    this.widgetContainer.statisticsService.sendWebRTCStats(webrtcStats)
  }

  processVideoStat(stats) {
    var videoStats = stats.receivers.video
    for (let statId in videoStats) {
      this.processStat(videoStats[statId], true)
    }
  }

  async render() {
    this.$element.innerHTML = templates.videoTemplate(this.getTemplateVariables())

    if (this.preInteractionFormEnabled) {
      this.$element.innerHTML += templates.preInteractionFormTemplate({
        form: this.preInteractionForm.video,
        styleNamespace: this.styleNamespace,
        submitButtonText: this.texts.callNow,
        texts: this.preInteractionFormTexts,
        additionalClassname: ``,
        formDataType: 'video',
      })
    }

    window.liveengage_gc_video_initialized = true
    if (this.chatCall) {
      this.setStatusClass('in-progress')
    }

    this.observeEvents()

    setTimeout(() => {
      if (this.preInteractionFormEnabled) {
        this.preInteractionFormIti.form = this.initPreInteractionForm(
          'video',
          this.params.defaultCountry || this.widgetContainer.settings.countryCode || DEFAULT_COUNTRY,
          this.filerCountriesText
        )
      }
    }, 0)

    const fullScreenButton = this.$element.querySelector(`.${this.styleNamespace}__more__options_list #toggle_full`)
    if (fullScreenButton) {
      const moreOptionsList = this.$element.querySelector(`.${this.styleNamespace}__more__options_list`)
      fullScreenButton.addEventListener('click', () => {
        const mainWindow = document.querySelector(`.cce-widget__window`)
        moreOptionsList.classList.toggle('show')
        mainWindow.classList.toggle('full_screen')
      })
    }
    return true
  }

  getTemplateVariables() {
    return {
      styleNamespace: this.styleNamespace,
      agreementQuestions: [],
      additionalFields: this.fields || [],
      phone: this.chatCall ? '' : this.params.phone,
      texts: this.texts,
      isMobile: this.isMobile,
      placement: this.widgetContainer.settings.widgets[this.widgetIndex].placement,
      cobrowseTexts: this.cobrowseTexts,
    }
  }

  async StartCall() {
    document.getElementById(`${this.styleNamespace}__remoteMedia`).muted = false
    if (!this.roomId) {
      await this.initVideo()
    }
    this.widgetContainer.isCallWaitSoundPlaying = true
    this.widgetContainer.playRingtone()
    this.triggerPublicEvent('action_call_start', { channel: 'video' })
    this.widgetContainer.triggerPublicEvent('widget_business_success', { state: widgetManager.getState(), confirmed: true })

    widgetManager.setWidgetTab('trueengage.video.ringing')

    this.remoteName = window.trueengage.get('videoRemoteName')

    let customAttributes = window.trueengage.get('customAttributes') || {}
    Object.assign(this.sipState, customAttributes)

    let call = this.webRTCClient.newCall({
      destinationNumber: this.params.phone,
      callerName: this.remoteName,
      video: false,
      clientState: btoa(JSON.stringify(this.sipState)),
    })

    call.getStats((stats) => {
      this.processStat(stats)
    })
  }

  hangupCall() {
    this.widgetContainer.stopRingtone()
    const mainWindow = document.querySelector(`.cce-widget__window`)
    mainWindow.classList.remove('full_screen')
    this.triggerPublicEvent('communication_ended', {
      communication_channel: 'video',
    })

    if (this.activeCall !== null) {
      this.activeCall.hangup()
    }

    this.removeCoBrowseInfoPanel()

    if (this.room) {
      this.room.disconnect()

      if (this.videoStatsInterval) {
        clearInterval(this.videoStatsInterval)
        this.videoStatsInterval = null
      }

      this.roomId = null
    }
    const targetNode = document.querySelector('.cce-widget-video')
    if (targetNode.className.split(' ').includes('chatCall') || this.chatCall) {
      const chatChannel = document.querySelector('.cce-widget-chat')
      const windowContent = document.querySelector('.cce-widget__window__content')
      const toggleChats = this.$element.querySelectorAll(`.${this.styleNamespace}__video-wrapper-chat-button`)
      toggleChats.forEach((toggleChat) => {
        toggleChat.classList.remove('chat-hide')
        toggleChat.classList.add('chat-show')
        const localVideoWrapper = document.querySelectorAll(
          '.cce-widget-video__video-wrapper-canvas, .cce-widget-video__video-wrapper-caller, .cce-widget-video__video-wrapper-template'
        )
        localVideoWrapper.forEach((video) => {
          video.classList.remove('chat-active')
        })
      })
      const avatars = document.querySelector('.cce-widget-video__avatar-wrapper-voice')
      if (avatars) {
        avatars.classList.remove('chat-active')
      }
      chatChannel.classList.add('open')
      targetNode.classList.remove('open')

      this.$element.classList.remove('chatCall')
      document.querySelector('.cce-widget__window__header').classList.remove(`cce-widget__window__header-chat-upgrade`)

      if (chatChannel && windowContent) {
        windowContent.appendChild(chatChannel)
      }
      widgetManager.setWidgetTab('trueengage.chat')
      let elem = document.querySelector('#cce-widget-chat__messages')
      elem.scrollTop = elem.scrollHeight
      this.$element.remove()
      return
    }
    if (widgetManager.getWidgetChannelInfo().channel === 'video') {
      widgetManager.setWidgetTab('trueengage.video.completed')
    }
  }

  setStatusClass(className, secondClassName) {
    const classes = ['initiated', 'ringing', 'in-progress', 'completed', 'settings', 'dial', 'pre-interaction-form']
    if (className === 'in-progress' || className === 'ringing') {
      document.querySelector('.cce-widget__window__header--close').classList.add('show-minimize')
    } else {
      document.querySelector('.cce-widget__window__header--close').classList.remove('show-minimize')
    }

    if (className === 'completed') {
      const widgetWindow = document.querySelector('.cce-widget__window')
      const callPopover = document.querySelector('.cce-widget__call__popover')
      const back = document.querySelector('.cce-widget__window__header--back')
      callPopover.classList.remove('open')
      back.classList.remove('cce-widget__window__header--back-hide')
      if (widgetWindow.classList.contains('minimized')) {
        document.querySelector('button[name=ccewBack]').click()
      }
    }
    let currentClass = Array.from(this.$element.classList).filter((x) => classes.includes(x))

    if (currentClass && currentClass.length > 0) {
      this.previousStatusClass = currentClass[0]
    }

    if (['ringing', 'in-progress'].includes(currentClass[0]) && ['settings', 'dial'].includes(className)) {
      this.$element.classList.add(className)
      return
    }
    this.$element.classList.remove('initiated', 'ringing', 'in-progress', 'completed', 'settings', 'dial', 'pre-interaction-form')
    this.$element.classList.add(className)
    if (secondClassName) {
      this.$element.classList.add(secondClassName)
    }
  }

  handleDialInputChange() {
    this.widgetContainer.playZipSound()
  }

  observeEvents() {
    this.$element.querySelector(`#${this.styleNamespace}__settings-back`).addEventListener('click', (_) => {
      widgetManager.setWidgetTab(widgetManager.getPreviousWidgetTab())
    })

    this.$element.querySelectorAll(`.${this.styleNamespace}__settings-button`).forEach((elem) =>
      elem.addEventListener('click', (_) => {
        widgetManager.setWidgetTab('trueengage.video.settings')
      })
    )

    const moreOptions = this.$element.querySelector(`.${this.styleNamespace}__more__options_button`)
    const moreOptionsList = this.$element.querySelector(`.${this.styleNamespace}__more__options_list`)
    moreOptions.addEventListener('click', () => {
      moreOptionsList.classList.toggle('show')
      document.querySelector('.cce-widget__window__header--back').classList.add('cce-widget__window__header--back-hide')
    })

    const toggleChats = this.$element.querySelectorAll(`.${this.styleNamespace}__video-wrapper-chat`)
    toggleChats.forEach((toggleChat) => {
      toggleChat.addEventListener('click', () => {
        const videoChannel = document.querySelector('.cce-widget-video__controls')
        const chatChannel = document.querySelector('.cce-widget-chat')
        const windowContent = document.querySelector('.cce-widget__window__content')
        if (toggleChat.classList.contains('chat-show')) {
          const localVideoWrapper = document.querySelectorAll(
            '.cce-widget-video__video-wrapper-canvas, .cce-widget-video__video-wrapper-caller, .cce-widget-video__video-wrapper-template'
          )
          localVideoWrapper.forEach((video) => {
            video.classList.add('chat-active')
          })
          toggleChat.classList.remove('chat-show')
          toggleChat.classList.add('chat-hide')
          chatChannel.classList.add('open')
          const avatars = document.querySelector('.cce-widget-video__avatar-wrapper-voice')
          if (avatars) {
            avatars.classList.add('chat-active')
          }
          if (chatChannel && videoChannel) {
            videoChannel.appendChild(chatChannel)
          }
          let elem = document.querySelector('#cce-widget-chat__messages')
          elem.scrollTop = elem.scrollHeight
        } else if (toggleChat.classList.contains('chat-hide')) {
          const localVideoWrapper = document.querySelectorAll(
            '.cce-widget-video__video-wrapper-canvas, .cce-widget-video__video-wrapper-caller, .cce-widget-video__video-wrapper-template'
          )
          localVideoWrapper.forEach((video) => {
            video.classList.remove('chat-active')
          })
          toggleChat.classList.remove('chat-hide')
          toggleChat.classList.add('chat-show')
          chatChannel.classList.remove('open')
          const avatars = document.querySelector('.cce-widget-video__avatar-wrapper-voice')
          if (avatars) {
            avatars.classList.remove('chat-active')
          }
          if (chatChannel && windowContent) {
            windowContent.appendChild(chatChannel)
          }
        }
      })
    })

    const settings = this.$element.querySelector(`.${this.styleNamespace}__more__options_list #toggle_settings`)
    settings.addEventListener('click', () => {
      widgetManager.setWidgetTab('trueengage.video.settings')
      // this.setStatusClass('settings')
      moreOptionsList.classList.toggle('show')
    })

    this.$element.querySelector(`.${this.styleNamespace}__dial-back button`).addEventListener('click', (_) => {
      if (this.chatCall) {
        this.setStatusClass('in-progress', 'chatCall')
        return
      }
      widgetManager.setWidgetTab(widgetManager.getPreviousWidgetTab())
    })

    this.$element.querySelector(`.${this.styleNamespace}__dial-button`).addEventListener('click', (_) => {
      if (this.chatCall) {
        this.setStatusClass('dial')
        return
      }
      widgetManager.setWidgetTab('trueengage.video.dial')
    })

    this.$element.querySelectorAll(`.${this.styleNamespace}__dial-item`).forEach((elem) =>
      elem.addEventListener('click', (_) => {
        const value = elem.textContent.trim()
        document.querySelector(`.${this.styleNamespace}__dial-input input`).value += value
        this.activeCall.dtmf(value)
        this.handleDialInputChange()
      })
    )

    this.$element.querySelector(`#${this.styleNamespace}__call-video`).addEventListener('click', (_) => {
      if (this.preInteractionFormEnabled) {
        widgetManager.setWidgetTab('trueengage.video.pre-interaction-form')
        const headerElement = document.querySelector('.cce-widget__window__header')
        headerElement.classList.add('cce-widget__window--with-pre-interaction-form')
        this.adjustPreInteractionFormConsentsStyles('video')
        return
      }
      this.StartCall()
    })

    this.$element.querySelector(`#${this.styleNamespace}__hangup`).addEventListener('click', (_) => {
      this.hangupCall()
    })

    this.$element.querySelector('form').addEventListener('submit', (e) => {
      e.preventDefault()
      e.stopPropagation()
    })

    this.$element.querySelector(`#${this.styleNamespace}__close`).addEventListener('click', (e) => {
      this.widgetContainer.stopRingtone()
      if (this.singleChannelBehavior === 'open_channel' && this.widgetContainer.settings.widgets[this.widgetIndex].channels.length === 1) {
        widgetManager.setWidgetTab('trueengage.video')
        widgetManager.closeWidget()
      } else {
        widgetManager.setWidgetTab('trueengage.channel_picker')
      }
    })

    if (this.preInteractionFormEnabled) {
      this.$element.querySelector(`.${this.styleNamespace}__pre-interaction-form`).addEventListener('submit', (event) => {
        event.preventDefault()
        event.stopPropagation()

        let formData = new FormData(event.target)

        let formValues = Object.fromEntries(formData.entries())
        if (!this.validatePreInteractionForm('video', this.preInteractionFormIti.form, this.preInteractionFormTexts)) return
        Object.keys(formValues).forEach((key) => {
          if (key.startsWith('consents[')) {
            delete formValues[key]
          }
        })

        event.target.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
          let match = checkbox.name.match(/^consents\[(.+)\]$/)
          if (match) {
            if (!formValues.consents) formValues.consents = {}
            formValues.consents[match[1]] = checkbox.checked
          }
        })

        if (this.preInteractionFormIti.form) {
          formValues.phoneNumber = this.preInteractionFormIti.form.getNumber()
        }

        this.sipState.trueengage_form = formValues

        this.StartCall()
        const headerElement = document.querySelector('.cce-widget__window__header')
        headerElement.classList.remove('cce-widget__window--with-pre-interaction-form')
      })
    }
  }
}
